export const dynamicViewportHeight = (property = 'height', offset?: string) => {
  const cssProperty = property.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`);
  const height = (unit: string) => (offset ? `calc(100${unit} - (${offset}))` : `100${unit}`);

  return {
    [property]: height('vh'),
    [`@supports (${cssProperty}: 100dvh)`]: {
      [property]: height('dvh'),
    },
  };
};
